export enum PlatformFeature {
  CaptchaScoreThreshold = 'captchaScoreThreshold',
}
